"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.THEMES = exports.AUTH_STRATEGY = exports.APF_MID_ACCESS_TOKEN = void 0;
var _constants = require("@mid/sdk/dist/lib/constants");
const APF_MID_ACCESS_TOKEN = exports.APF_MID_ACCESS_TOKEN = 'apf-mid-access-token';
var _default = exports.default = {
  AUTH_STATE: 'auth_state',
  AUTH_NONCE: 'auth_nonce',
  RETURN_URL: 'return_url',
  MID_LAST_VISITED_URL: '_mid-last-visited-url',
  COMPLETED: 'completed',
  THEME_KEY: 'theme',
  MENU_KEY: 'menu_nodes',
  MENU_EXPANDED: 'menu_expanded',
  APPCONFIG: 'appconfig',
  PCAS_XSRF_COOKIE_NAME: 'pcas_csrf_token',
  PCAS_CONNECTOR: 'pcas',
  MID2_CONNECTOR: 'mid2',
  MID_ACCESS_TOKEN_KEY: _constants.MID_ACCESS_TOKEN_KEY
};
const THEMES = exports.THEMES = {
  mds: 'mds',
  prizm: 'prizm',
  prizmNext: 'prizm-next'
};
const AUTH_STRATEGY = exports.AUTH_STRATEGY = {
  NO_AUTH: 'NoAuthStrategy',
  PCAS: 'PCASAuthStrategy',
  MID2: 'MID2AuthStrategy'
};